export default __webpack_public_path__ + "static/media/guaranteed-icon.6056c4d9.svg";